// extracted by mini-css-extract-plugin
export default {"para":"Navbar_para__MkP65","small":"Navbar_small__KQCnF","link":"Navbar_link__oMXg4","spans":"Navbar_spans__hGMj3","cont":"Navbar_cont__z2Tmv","lists":"Navbar_lists__lcG7j"};